import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
    selector: 'month-dialog',
    templateUrl: './month-dialog.component.html',
    styleUrls: ['./month-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MonthDialogComponent implements OnInit {
    dialogTitle: string;
    public monthForm: FormGroup;
    months: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    monthsStr: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril',
        'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    constructor(public matDialogRef: MatDialogRef<MonthDialogComponent>,
                @Inject(MAT_DIALOG_DATA) private _data: any,
                private _formBuilder: FormBuilder) {

        this.dialogTitle = 'Exportación';
        this.monthForm = this.createMonthForm();
    }

    ngOnInit(): void {
    }

    private createMonthForm(): FormGroup{
        const fecha: Date = new Date();
        fecha.setMonth(fecha.getMonth() - 1);

        return this._formBuilder.group({
            month          : [fecha.getMonth()],
            year         : [fecha.getFullYear()]
        });
    }
}
